import { AccordionGroup, Stack } from "@mui/joy";
import AccordionTemplate from "./AccordionTemplate";
import ListItem from "@mui/joy/ListItem";
import List from "@mui/joy/List";
import { theme } from "styles/theme";

const counselingDifferences = [
  "코치 선생님이 매일 피드백과 맞춤 활동을 준비해 줍니다.",
  "비실시간으로 코치 선생님과 소통하기에, 언제든 편한 시간에 참여할 수 있습니다.",
  "마음 건강을 다스리는 데에 필요한 인지치료 이론과 기술들을 체계적으로 습득합니다.",
];

export default function FAQTypeB() {
  return (
    <AccordionGroup
      sx={{
        display: "flex",
        "& .MuiAccordionSummary-button": {
          backgroundColor: "transparent !important",
          boxShadow: "none !important",
          "&:hover, &:focus, &:active, &.Mui-focusVisible": {
            backgroundColor: "transparent !important",
            boxShadow: "none !important",
            outline: "none !important",
          },
        },
        // 혹시 다른 슬롯도 필요하면 추가
        "& .MuiAccordionSummary-content": {
          backgroundColor: "transparent !important",
        },
      }}
    >
      <Stack>
        <AccordionTemplate
          summary={"누가 도움 받을 수 있나요?"}
          details={[
            "우울함, 수치심, 무기력, 폭식을 비롯한 식이장애, 불안감, 강박적인 걱정, 공황장애, 사회공포증, 발표불안, 자기 파괴적 완벽주의, 업무에 대한 부담감, 수면 문제 그리고 이외 복합적인 정서 문제에 도움이 될 수 있어요.",
            <br />,
            <br />,
            "환청, 환각, 자살사고 등 시급한 의료적 접근이 필요한 분들의 경우 당장의 도움이 될 수 없어요. 단, 의료적 접근을 통해 위 문제들이 안정화가 된 상태에서는 보다 장기적이고 지속적인 변화를 위해 디스턴싱을 시작해봐도 괜찮아요.",
          ]}
        />
        <AccordionTemplate
          summary={"심리상담과 무엇이 다른가요?"}
          details={[
            "대화를 통해 진행되는 심리상담과 달리 디스턴싱 프로그램은 다음과 같은 차이를 갖습니다.",
            <br />,
            <br />,
            <List marker="disc" sx={{ py: 0 }}>
              {counselingDifferences.map((text, index) => (
                <ListItem
                  key={index}
                  sx={{
                    minHeight: "auto",
                    fontWeight: 500,
                    color: theme.vars.palette.Content.Strong,
                    lineHeight: 1.32,
                    p: 0,
                    pb: 0.5,
                  }}
                >
                  {text}
                </ListItem>
              ))}
            </List>,
          ]}
        />
        <AccordionTemplate
          summary={"PC에서는 어떻게 이용하나요?"}
          details={[
            "PC에서는 웹 브라우저에서 https://distancing.im에 접속하여 디스턴싱을 이용할 수 있어요.",
          ]}
        />

        <AccordionTemplate
          summary={"태블릿에서는 어떻게 이용하나요?"}
          details={[
            "태블릿에서는 두 가지 방법으로 디스턴싱을 이용할 수 있어요.",
            <br />,
            <br />,
            "- App Store 또는 Google Play에서 ‘디스턴싱’ 앱을 다운로드하여 이용",
            <br />,
            "- Chrome이나 Safari 같은 웹 브라우저에서 https://distancing.im에 접속하여 이용",
          ]}
        />

        <AccordionTemplate
          summary={"앱에 비밀번호를 설정할 수 있나요?"}
          details={[
            "‘나’ 탭에서 '앱 잠금'으로 들어가면 비밀번호를 설정할 수 있어요.",
          ]}
        />

        <AccordionTemplate
          summary={"코치와 전화 또는 채팅 상담도 가능한가요?"}
          details={[
            "디스턴싱은 마음을 다루는 기술을 익혀나가는 디지털 인지치료 프로그램으로서, 전화 상담이나 채팅 상담은 제공하지 않아요.",
            <br />,
            <br />,
            "대화를 통한 상담이 필요하시면 가까운 정신건강의학과나 상담센터 방문을 권해드립니다.",
          ]}
        />

        <AccordionTemplate
          summary={"활동은 언제 업데이트 받을 수 있나요?"}
          details={[
            "코치 선생님은 평일 오전 8시부터 오후 7시 사이에 활동 업데이트를 해드리고 있답니다.",
            <br />,
            <br />,
            "직접 확인 후 다음 활동을 정성껏 준비하는 작업이라, 정확한 예정 시각을 확정하기 어려운 점 양해 부탁드립니다.",
            <br />,
            <br />,
            "[활동 업데이트 규정]",
            <br />,
            <br />,
            "플랜별 최대 업데이트 횟수",
            <br />,
            "- 스타터 플랜: 주 최대 2회",
            <br />,
            "- 챌린저 플랜: 일 최대 1회",
            <br />,
            "- 마스터 플랜: 일 최대 2회",
            <br />,
            <br />,
            "업데이트 제공 기준",
            <br />,
            "- 오후 3시 이전까지 파란색 원으로 표시된 주어진 활동지가 모두 완료되었다면, 당일 업데이트",
            <br />,
            "- 오후 3시 이후에 파란색 원으로 표시된 주어진 활동지가 모두 완료되었다면, 다음 업무일 업데이트",
            <br />,
            <br />,
            "주말과 공휴일은 코치 선생님의 휴무일로 활동 업데이트가 어렵습니다.",
          ]}
        />

        <AccordionTemplate
          summary={"활동은 정해진 시간 안에 마쳐야 하나요?"}
          details={[
            "활동을 언제까지 마쳐야 한다는 시간제한은 없어요.",
            <br />,
            <br />,
            "개인의 상황에 따라 24시간 언제든 편한 시간에 진행하면 된답니다.",
          ]}
        />

        <AccordionTemplate
          summary={"활동은 매일 해야 하나요?"}
          details={[
            "활동을 매일 진행하지 않아도 괜찮습니다.",
            <br />,
            <br />,
            "매일 진행하는 것보다 중요한 것은 규칙적으로 진행하는 것입니다.",
            <br />,
            <br />,
            "때문에 매주 특정 요일과 시각을 디스턴싱하는 시간으로 정해 놓는 것을 추천드려요.",
            <br />,
            <br />,
            "꾸준히 실천할 수 있는 시간을 찾아 규칙적인 습관으로 만들어 보세요.",
          ]}
        />

        <AccordionTemplate
          summary={"활동은 어떻게 진행하면 되나요?"}
          details={[
            "‘홈’ 탭에 보이는 활동지를 위에서부터 아래로 순서대로 진행하면 됩니다.",
            <br />,
            <br />,
            "특히 연관된 활동지는 선으로 묶여 있으니 순서에 유의해 주세요.",
            <br />,
            <br />,
            "또한 이전에 진행한 활동지에 대해 코치 선생님이 코멘트를 남겨 다시 드린 것도 있을 거랍니다.",
            <br />,
            <br />,
            "활동은 크게 <생각기록지>, <명상훈련지>, <배움활동지> 세 가지로 나뉘어요.",
            <br />,
            <br />,
            "<생각기록지>와 <명상훈련지>에서는 프로그램의 전반에 걸쳐 배운 디스턴싱 기술을 자기 주도적으로 실생활에 적용하는 연습을 합니다.",
            <br />,
            <br />,
            "한편 <배움활동지>에서는 <생각기록지>와 <명상훈련지>를 보조하는 이론 학습을 하게 돼요.",
          ]}
        />

        <AccordionTemplate
          summary={"진행 속도나 분량을 조절할 수 있나요?"}
          details={[
            "진행 속도와 분량은 코치 선생님이 조절해 드립니다.",
            <br />,
            <br />,
            "코치 선생님은 개인의 특성과 상황, 이해 수준이나, 문제의 경중에 맞게 속도와 분량을 조절하며 프로그램을 진행하고 있어요.",
            <br />,
            <br />,
            "속도나 분량에 있어 불편한 부분을 코치 선생님에게 알려주시면, 그에 맞게 다시 조절해 드릴 겁니다.",
          ]}
        />

        <AccordionTemplate
          summary={"궁금한 점이 있으면 어떻게 하나요?"}
          details={[
            "코치 선생님에게 편하게 질문해 주세요.",
            <br />,
            <br />,
            "디스턴싱의 코치 선생님은 높은 수준의 자격 요건을 갖추시고 강도 높은 교육 과정을 거치신 국내 최고의 인지치료 전문가입니다.",
            <br />,
            <br />,
            "조금이라도 이해가 어려운 부분이 있다면 백 번이고 물어보시며, 전담 코치 선생님을 200% 활용하시길 바라요.",
          ]}
        />

        <AccordionTemplate
          summary={"코치는 실제 사람인가요?"}
          details={[
            "코치는 실제 사람이에요.",
            <br />,
            <br />,
            "단순 알림 목적의 메시지 외에는 모두 코치와 직접 대화를 나누며 프로그램을 진행합니다.",
          ]}
        />

        <AccordionTemplate
          summary={"코치는 어떤 자격을 갖춘 분들인가요?"}
          details={[
            "디스턴싱 코치는 심리학 분야에서 석사 이상의 학위를 갖추고, 상담심리사(한국상담심리학회), 임상심리전문가(한국심리학회/한국임상심리학회), 정신건강임상심리사(보건복지부), 전문상담사(한국상담학회) 자격증을 갖춘 심리 전문가들로 구성되어 있어요.",
            <br />,
            <br />,
            "또한 디스턴싱의 코치는 강도 높은 교육과 훈련을 거친 국내 최고의 인지치료 전문가입니다.",
          ]}
        />

        <AccordionTemplate
          summary={"나를 담당하는 코치는 한 분인가요?"}
          details={[
            "담당 코치 선생님은 한 명입니다.",
            <br />,
            <br />,
            "프로그램을 시작하면 진행을 도와줄 담당 코치 선생님이 한 명 배정됩니다.",
          ]}
        />

        <AccordionTemplate
          summary={"비밀이 보장되나요?"}
          details={[
            "비밀은 완벽히 보장됩니다.",
            <br />,
            <br />,
            "프로그램에서 오가는 모든 내용은 이용자와 담당 코치만 볼 수 있어요.",
            <br />,
            <br />,
            "또한 데이터는 암호화되어 저장되고 개인정보보호법에 따라 안전하게 관리되고 있습니다.",
          ]}
        />
        <AccordionTemplate
          summary={"환불이 가능한가요?"}
          details={[
            "아래 환불 규정에 따라 환불이 가능합니다.",
            <br />,
            <br />,
            "[환불 규정]",
            <br />,
            "- 첫 100일의 경우, 결제 후 활동지를 한 번도 진행하지 않으신 경우에 한해 전액 환불이 가능합니다. 활동지를 1회 이상 마치셨다면 환불은 불가합니다.",
            <br />,
            "- 첫 100일 이후 연장 이용의 경우, 기간 내 문제가 해결되어 이용 종료를 원하신다면 남은 기간에 대해 일할 계산하여 환불이 가능합니다.",
            <br />,
            <br />,
            "환불 요청은 닉네임과 회원번호를 포함해 메일(support@orwellhealth.org)로 넣어주세요.",
          ]}
        />
        <AccordionTemplate
          summary={"효과를 못 느끼면 페이백해준다고요?"}
          details={[
            "첫 100일을 모두 이용하신 뒤에도 변화를 느끼지 못하신 경우, 비용 전액을 돌려드리고 있습니다.",
            <br />,
            <br />,
            "[페이백 규정]",
            <br />,
            "- 결제 이후 첫 100일 동안 최소 주 1회 주어진 모든 활동지를 마치며 프로그램을 꾸준히 진행하신 경우에만 페이백이 가능합니다.",
            <br />,
            "- 첫 100일을 모두 이용하신 후, 10일 이내에 신청이 가능합니다.",
            <br />,
            "- 페이백 제도는 첫 100일 이용에만 적용되며, 프로그램 추가 연장 이용부터는 적용되지 않습니다.",
            <br />,
            <br />,
            "페이백 요청은 닉네임과 회원번호를 포함해 메일(support@orwellhealth.org)로 넣어주세요.",
          ]}
          noBorder
        />
      </Stack>
    </AccordionGroup>
  );
}
